import PageContainer from '../../../components/layout/PageContainer';

const DashboardSkeleton = () => {
  return (
    <PageContainer className="pb-10">
      {/* ================= SECTION 1: DASHBOARD GET STARTED SKELETON ================= */}
      <div className="w-full">
        <div className="grid grid-cols-1 min-[900px]:grid-cols-12 gap-5 lg:gap-6 items-stretch">
          
          {/* Left Card: Voucher Generator Skeleton (col-span 7/8) */}
          <div className="col-span-1 min-[900px]:col-span-7 xl:col-span-7 2xl:col-span-8 bg-white rounded-2xl sm:rounded-3xl p-4 sm:p-5 lg:p-6 border border-slate-100 shadow-sm flex flex-col justify-between min-[900px]:h-[385px] min-[900px]:max-h-[385px] overflow-hidden">
            <div>
              {/* Header: Title + Badge */}
              <div className="flex items-start sm:items-center justify-between gap-3 mb-2">
                <div className="flex-1 space-y-2">
                  <div className="h-6 sm:h-7 w-48 sm:w-56 bg-slate-200 rounded-xl animate-pulse" />
                  <div className="h-3.5 sm:h-4 w-64 sm:w-80 max-w-full bg-slate-100 rounded-lg animate-pulse" />
                </div>
                <div className="h-6 w-24 bg-primary/15 border border-primary/20 rounded-full animate-pulse shrink-0 ml-auto" />
              </div>

              {/* 3 Upload Boxes Grid */}
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-3.5 mt-4 mb-2">
                {/* Box 1: Hotel */}
                <div className="h-[155px] sm:h-[165px] rounded-2xl p-3.5 sm:p-4 border-2 border-dashed border-primary/25 bg-teal-50/20 flex flex-col justify-between">
                  <div>
                    <div className="flex items-center justify-between gap-1.5 mb-2">
                      <div className="flex items-center gap-1.5">
                        <div className="w-6 h-6 rounded-lg bg-primary/15 animate-pulse" />
                        <div className="h-3.5 w-12 bg-slate-200 rounded animate-pulse" />
                      </div>
                      <div className="h-4 w-14 rounded-full bg-primary/15 animate-pulse" />
                    </div>
                    <div className="h-2.5 w-28 bg-slate-100 rounded animate-pulse mt-1.5" />
                  </div>
                  <div className="h-8 w-full bg-white border border-teal-200/60 rounded-xl animate-pulse shadow-2xs" />
                </div>

                {/* Box 2: Flight / Tickets */}
                <div className="h-[155px] sm:h-[165px] rounded-2xl p-3.5 sm:p-4 border-2 border-dashed border-slate-200 bg-slate-50/50 flex flex-col justify-between">
                  <div>
                    <div className="flex items-center justify-between gap-1.5 mb-2">
                      <div className="flex items-center gap-1.5">
                        <div className="w-6 h-6 rounded-lg bg-slate-200 animate-pulse" />
                        <div className="h-3.5 w-12 bg-slate-200 rounded animate-pulse" />
                      </div>
                      <div className="h-4 w-14 rounded-full bg-slate-200 animate-pulse" />
                    </div>
                    <div className="h-2.5 w-28 bg-slate-100 rounded animate-pulse mt-1.5" />
                  </div>
                  <div className="h-8 w-full bg-white border border-slate-200 rounded-xl animate-pulse shadow-2xs" />
                </div>

                {/* Box 3: Itinerary */}
                <div className="h-[155px] sm:h-[165px] rounded-2xl p-3.5 sm:p-4 border-2 border-dashed border-slate-200 bg-slate-50/50 flex flex-col justify-between">
                  <div>
                    <div className="flex items-center justify-between gap-1.5 mb-2">
                      <div className="flex items-center gap-1.5">
                        <div className="w-6 h-6 rounded-lg bg-slate-200 animate-pulse" />
                        <div className="h-3.5 w-14 bg-slate-200 rounded animate-pulse" />
                      </div>
                      <div className="h-4 w-14 rounded-full bg-slate-200 animate-pulse" />
                    </div>
                    <div className="h-2.5 w-28 bg-slate-100 rounded animate-pulse mt-1.5" />
                  </div>
                  <div className="h-8 w-full bg-white border border-slate-200 rounded-xl animate-pulse shadow-2xs" />
                </div>
              </div>
            </div>

            {/* Bottom Action Bar */}
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 pt-2.5 border-t border-slate-100">
              <div className="h-9 w-36 bg-primary/20 rounded-xl animate-pulse" />
              <div className="h-4 w-36 bg-slate-100 rounded-lg animate-pulse" />
            </div>
          </div>

          {/* Right Card: Checklist / Updates Skeleton (col-span 5/4) */}
          <div className="col-span-1 min-[900px]:col-span-5 xl:col-span-5 2xl:col-span-4 bg-white rounded-2xl sm:rounded-3xl p-4 sm:p-5 lg:p-6 border border-slate-100 shadow-sm flex flex-col justify-between min-[900px]:h-[385px] min-[900px]:max-h-[385px] overflow-hidden">
            <div>
              {/* Header: Title + Tab Pills */}
              <div className="flex items-center justify-between pb-2.5 sm:pb-3 border-b border-slate-100 mb-3 gap-2">
                <div className="h-5 w-24 bg-slate-200 rounded-lg animate-pulse" />
                <div className="flex items-center gap-1.5 p-1 bg-slate-100/80 rounded-xl">
                  <div className="h-6 w-14 bg-primary/20 rounded-lg animate-pulse" />
                  <div className="h-6 w-14 bg-slate-200 rounded-lg animate-pulse" />
                </div>
              </div>

              {/* Progress Bar Skeleton */}
              <div className="space-y-1.5 mb-4">
                <div className="flex items-center justify-between">
                  <div className="h-3 w-20 bg-slate-200 rounded animate-pulse" />
                  <div className="h-3 w-8 bg-slate-200 rounded animate-pulse" />
                </div>
                <div className="h-2 w-full bg-slate-100 rounded-full overflow-hidden">
                  <div className="h-full w-2/3 bg-primary/30 rounded-full animate-pulse" />
                </div>
              </div>

              {/* Checklist Items */}
              <div className="space-y-2.5">
                {[1, 2, 3].map((i) => (
                  <div key={i} className="flex items-center gap-2.5 p-2 rounded-xl bg-slate-50/60 border border-slate-100">
                    <div className="w-5 h-5 rounded-full bg-slate-200 animate-pulse shrink-0" />
                    <div className="flex-1 min-w-0 space-y-1">
                      <div className="h-3.5 w-32 bg-slate-200 rounded animate-pulse" />
                      <div className="h-2.5 w-44 bg-slate-100 rounded animate-pulse" />
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Bottom button skeleton */}
            <div className="pt-2 border-t border-slate-100">
              <div className="h-8 w-28 bg-slate-100 rounded-xl animate-pulse" />
            </div>
          </div>

        </div>
      </div>

      {/* ================= SECTION 2: SAMPLE VOUCHER SKELETON ================= */}
      <div className="w-full bg-white rounded-2xl sm:rounded-3xl p-4 sm:p-6 lg:p-7 xl:p-8 border border-slate-100 shadow-sm">
        <div className="grid grid-cols-1 xl:grid-cols-12 gap-6 xl:gap-8 items-center xl:items-start">

          {/* Left Column: Sample Voucher Header + Ticket Stub (xl:col-span-8) */}
          <div className="xl:col-span-8 flex flex-col space-y-3.5 sm:space-y-4">
            <div>
              <div className="h-6 sm:h-7 w-40 bg-slate-200 rounded-xl animate-pulse" />
              <div className="h-3.5 sm:h-4 w-80 max-w-full bg-slate-100 rounded-lg animate-pulse mt-2" />
            </div>

            {/* Ticket Card Skeleton */}
            <div className="bg-white rounded-2xl sm:rounded-3xl border border-[#c2ecea] shadow-xs overflow-hidden flex flex-col md:flex-row relative">
              {/* Main Ticket Body */}
              <div className="flex-1 bg-white p-3.5 sm:p-5 lg:p-6 flex flex-col justify-between space-y-4">
                <div>
                  {/* Top Tag & Status */}
                  <div className="flex flex-wrap items-center justify-between gap-2">
                    <div className="flex items-center gap-2">
                      <div className="h-6 w-16 bg-slate-200 rounded animate-pulse" />
                      <div className="h-3 w-40 bg-slate-100 rounded animate-pulse" />
                    </div>
                    <div className="h-5 w-28 bg-teal-50 border border-teal-200/50 rounded-full animate-pulse" />
                  </div>

                  {/* Flight Cities Header with Airplane Path */}
                  <div className="flex items-center justify-between gap-3 mt-4">
                    <div className="h-7 w-24 bg-slate-200 rounded-lg animate-pulse" />
                    <div className="flex-1 mx-3 flex items-center relative">
                      <div className="w-full border-t-2 border-dashed border-teal-200/70" />
                      <div className="absolute left-1/2 -translate-x-1/2 w-6 h-6 rounded-full bg-[#eaf7f5] border border-[#c2ecea] animate-pulse" />
                    </div>
                    <div className="h-7 w-20 bg-slate-200 rounded-lg animate-pulse" />
                  </div>

                  {/* 6 Grid Specs */}
                  <div className="grid grid-cols-2 sm:grid-cols-3 gap-3.5 mt-4 pt-3 border-t border-slate-100">
                    {[1, 2, 3, 4, 5, 6].map((idx) => (
                      <div key={idx} className="space-y-1">
                        <div className="h-2.5 w-14 bg-slate-200 rounded animate-pulse" />
                        <div className="h-3.5 w-24 bg-slate-100 rounded animate-pulse" />
                      </div>
                    ))}
                  </div>
                </div>

                {/* Ticket Footer Action Button */}
                <div className="pt-3 border-t border-slate-100">
                  <div className="h-8 w-36 bg-primary/20 rounded-xl animate-pulse" />
                </div>
              </div>

              {/* Right Perforated Stub */}
              <div className="w-full md:w-48 bg-[#f2faf8] border-t-2 md:border-t-0 md:border-l-2 border-dashed border-[#b6e7e4] p-4 sm:p-5 flex flex-col items-center justify-center text-center space-y-2.5">
                <div className="h-3 w-20 bg-teal-100 rounded animate-pulse" />
                <div className="h-8 w-24 bg-white border border-teal-200 rounded-xl animate-pulse shadow-2xs" />
                <div className="h-2.5 w-24 bg-slate-200/70 rounded animate-pulse" />

                {/* QR Code Box */}
                <div className="w-16 h-16 bg-white border border-teal-200/80 rounded-xl animate-pulse flex items-center justify-center mt-1" />
                <div className="h-2 w-20 bg-slate-200/70 rounded animate-pulse" />
              </div>
            </div>

            {/* Footnote text */}
            <div className="flex items-center gap-1.5">
              <div className="w-3.5 h-3.5 rounded-full bg-primary/20 animate-pulse shrink-0" />
              <div className="h-3 w-96 max-w-full bg-slate-100 rounded animate-pulse" />
            </div>
          </div>

          {/* Right Column: Traveller Phone Frame Mockup Skeleton (xl:col-span-4) */}
          <div className="w-full xl:col-span-4 flex flex-col items-center justify-center pt-4 xl:pt-0 space-y-3">
            <div className="text-center space-y-1">
              <div className="h-3.5 w-32 bg-slate-200 rounded animate-pulse mx-auto" />
              <div className="h-3 w-40 bg-teal-100 rounded animate-pulse mx-auto" />
            </div>

            {/* Phone Chassis */}
            <div className="w-[185px] xs:w-[195px] sm:w-[205px] h-[370px] xs:h-[390px] sm:h-[410px] bg-slate-900 rounded-[28px] p-[2.5px] shadow-lg border border-slate-700/60 relative overflow-hidden shrink-0">
              <div className="rounded-[25px] overflow-hidden bg-slate-950 w-full h-full p-3.5 flex flex-col justify-between relative">
                {/* Phone Header notch & bar */}
                <div className="space-y-2">
                  <div className="h-3 w-16 bg-slate-800 rounded-full mx-auto animate-pulse" />
                  <div className="h-4 w-28 bg-slate-800/80 rounded-lg animate-pulse" />
                </div>

                {/* Phone Main Screen mock */}
                <div className="space-y-2.5 my-auto">
                  <div className="h-36 w-full bg-slate-800/60 rounded-2xl animate-pulse" />
                  <div className="h-3 w-3/4 bg-slate-800 rounded animate-pulse" />
                  <div className="h-2.5 w-1/2 bg-slate-800/70 rounded animate-pulse" />
                </div>

                {/* Phone bottom controls */}
                <div className="h-7 w-full bg-slate-800/90 rounded-xl animate-pulse" />
              </div>
            </div>

            {/* Phone caption */}
            <div className="h-3.5 w-28 bg-slate-200 rounded animate-pulse" />
          </div>

        </div>
      </div>

      {/* ================= SECTION 3: TRAVELLER APP FEATURES SKELETON ================= */}
      <div className="w-full bg-white rounded-2xl sm:rounded-3xl p-4 sm:p-6 lg:p-7 xl:p-8 border border-slate-100 shadow-sm">
        {/* Header */}
        <div className="space-y-2 mb-5">
          <div className="h-6 w-60 bg-slate-200 rounded-xl animate-pulse" />
          <div className="h-3.5 w-80 max-w-full bg-slate-100 rounded-lg animate-pulse" />
        </div>

        {/* 3 Marketplace Feature Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {[1, 2, 3].map((idx) => (
            <div key={idx} className="p-4 sm:p-5 rounded-2xl border border-slate-100 bg-slate-50/50 flex flex-col justify-between h-36">
              <div className="space-y-2">
                <div className="flex items-center gap-2.5">
                  <div className="w-7 h-7 rounded-xl bg-primary/15 animate-pulse" />
                  <div className="h-4 w-20 bg-slate-200 rounded animate-pulse" />
                </div>
                <div className="h-3 w-full bg-slate-100 rounded animate-pulse" />
                <div className="h-3 w-3/4 bg-slate-100 rounded animate-pulse" />
              </div>
              <div className="h-3 w-36 bg-primary/10 rounded-full animate-pulse mt-2" />
            </div>
          ))}
        </div>

        {/* Utilities Pills Row */}
        <div className="flex flex-wrap gap-2 mt-4 pt-3 border-t border-slate-100">
          {[1, 2, 3, 4, 5, 6, 7, 8].map((idx) => (
            <div key={idx} className="h-7 w-28 bg-slate-100 rounded-full animate-pulse" />
          ))}
        </div>
      </div>

    </PageContainer>
  );
};

export default DashboardSkeleton;
